import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { usePermissions, useSession } from 'src/apps/invest/common/hooks';
import { ROUTES } from 'src/apps/invest/config';
import { useActivityViewModel } from '../models/ActivityViewModel';
import { ActivityPage } from '../views/ActivityPageView';

const sessionRedirect = ROUTES.activity;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

export const ActivityController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  const model = useActivityViewModel();
  const { investorAccount } = useInvestorAccountModel();
  const { properties, fetchProperties } = usePropertiesModel();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;

    await model.fetchActivity();
    if (!properties && investorAccount?.id) {
      await fetchProperties(investorAccount.id);
    }
  }

  useEffect(() => {
    init();
  }, []);
  return <ActivityPage />;
};
